import { Link } from 'react-router-dom'

import { formatUtcAsThai } from '../lib/datetime'
import { upcomingFor } from '../lib/nav'
import { useAuthedSession } from '../lib/SessionContext'
import { roleLabel } from '../lib/session'
import NewsFeed from './NewsFeed'
import SlideShow from './SlideShow'

export default function Home() {
  const session = useAuthedSession()
  const upcoming = upcomingFor(session)

  return (
    <>
      <h1>สวัสดี {session.displayName}</h1>

      {/* สไลด์ banner บนสุด แล้วตามด้วยข่าว/ประกาศ — เงียบเองถ้าไม่มีของ (ดู SlideShow/NewsFeed) */}
      <SlideShow />
      <NewsFeed />

      <section className="card">
        <h2>บัญชีที่ใช้อยู่</h2>
        <dl>
          <dt>บริษัท</dt>
          <dd>{session.company}</dd>

          <dt>ชื่อผู้ใช้</dt>
          <dd>{session.username}</dd>

          <dt>รหัสพนักงาน</dt>
          <dd>{session.empCode ?? '-'}</dd>

          {session.kind === 'admin' ? (
            <>
              <dt>สิทธิ์</dt>
              <dd>{roleLabel(session.role)}</dd>

              <dt>อีเมล</dt>
              <dd>{session.email ?? '-'}</dd>

              <dt>เข้าระบบล่าสุด</dt>
              <dd>{session.lastLoginAt ? formatUtcAsThai(session.lastLoginAt) : 'ครั้งนี้เป็นครั้งแรก'}</dd>
            </>
          ) : (
            <>
              <dt>แผนก</dt>
              <dd>{session.department ?? '-'}</dd>

              <dt>ตำแหน่ง</dt>
              <dd>{session.position ?? '-'}</dd>
            </>
          )}
        </dl>
      </section>

      {session.kind === 'admin' && session.role === 'viewer' && (
        <p className="warn">สิทธิ์ของบัญชีนี้คือดูข้อมูลเท่านั้น เมนูที่แก้ไข/อนุมัติจะไม่แสดง</p>
      )}

      <section className="card">
        <h2>เมนูที่กำลังจะมา</h2>
        <p className="meta">ยังเป็นหน้าเปล่า รอต่อข้อมูลจริงจาก backend</p>
        <ul className="todo-list">
          {upcoming.map((item) => (
            <li key={item.path}>
              <Link to={item.path}>{item.label}</Link>
              <span className="meta">{item.note}</span>
            </li>
          ))}
        </ul>
      </section>
    </>
  )
}
